import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicCardFeed {
  constructor(section) {
    this.el = section.el;
    this.section = section;
    this.cardGap = section.data.cardGap * 4;
    this.cardCount = section.data.cardCount;
    this.cardCountTiny = section.data.cardCountTiny;
    this.cardCountMobile = section.data.cardCountMobile;
    this.cardCountTablet = section.data.cardCountTablet;
    this.cardCountDesktop = section.data.cardCountDesktop;

    initCarousel(this.el, {
      perPage: this.cardCountTiny,
      gap: this.cardGap,
      mediaQuery: 'min',
      breakpoints: {
        [unitlessBreakpoints.xs]: {
          perPage: this.cardCountMobile,
        },
        [unitlessBreakpoints.md]: {
          perPage: this.cardCountTablet,
        },
        [unitlessBreakpoints.lg]: {
          perPage: this.cardCountDesktop,
        },
      },
    });
  }
}
